import {
  BlueprintParameterValue,
  BlueprintParameterValueType,
  BlueprintStepTemplate,
} from "../../../models/Blueprints";
import CreateOrUpdateForm from "./CreateOrUpdateForm";

interface Props {
  stepID: string;
  stepTemplate: BlueprintStepTemplate;
}

const BlueprintEditorRightPanelUpdateByModelIDForm = ({ stepID, stepTemplate }: Props) => {
  const validator = (valueKey: string, parameterValue: BlueprintParameterValue) => {
    if (valueKey === "id") {
      return parameterValue.value_type !== BlueprintParameterValueType.none;
    }
    if (parameterValue.is_unique_identifier) {
      return parameterValue.value_type === BlueprintParameterValueType.none;
    }
    return true;
  };
  return (
    <CreateOrUpdateForm
      stepID={stepID}
      stepTemplate={stepTemplate}
      validator={validator}
      anchorIdentifiersToTop
    />
  );
};

export default BlueprintEditorRightPanelUpdateByModelIDForm;
